import useApi from '@hooks/useApi';
import { CloseRounded } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { getPaddleInstance } from '@paddle/paddle-js';
import { useAuthInfo } from '@propelauth/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DonbarCheckout = ({ open, onClose, height, priceId }) => {
    const {
        t,
        i18n: { language: locale },
    } = useTranslation();

    const { activeOrg } = useApi();
    const { orgId } = activeOrg;
    const { user } = useAuthInfo();

    const paddle = getPaddleInstance();

    useEffect(() => {
        setTimeout(() => {
            paddle?.Checkout.open({
                items: [
                    {
                        priceId,
                        quantity: 1,
                    },
                ],
                customer: { email: user?.email }, // Pre-fill if known
                customData: { user_id: user?.userId, org_id: orgId }, // Vital for linking to your DB
                settings: {
                    displayMode: 'inline',
                    frameTarget: 'checkout-container',
                    frameInitialHeight: 1,
                    frameStyle:
                        'width: 100%; min-width: 286px; background-color: transparent; border: none;',
                    locale,
                    variant: 'one-page',
                },
            });
        }, 225);
    }, []);

    return (
        <Dialog
            PaperProps={{
                sx: {
                    backgroundColor: 'surfaceContainerLow.main',
                    minHeight: height,
                },
            }}
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>{t('Upgrade Subscription')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={theme => ({
                    position: 'absolute',
                    right: 16,
                    top: 16,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseRounded />
            </IconButton>
            <DialogContent
                className="checkout-container"
                sx={{ textAlign: 'center', p: 2, pb: 0 }}
            ></DialogContent>
        </Dialog>
    );
};

export default DonbarCheckout;
